<template lang="pug">
div
  announcement
  .container
    .slot-wrapper 
      gameSearch(@search="searchKey")
      .slot-thumnails 
        .row(v-if="gameList.length > 0")
          .col-3(v-for="game in searchList()")
            .icon-star(@click="toggleFav(game)" :class="{ 'active' : isFav(game.GameId) }")
              i.fa-star.fa-solid
            a(href='javascript:void(0)' @click="launchGame(game.GameId)") 
              .slot-picture
                img.img-fluid(:src="game.ImageUrl")
              .slot-name {{ game.GameName }}
        .d-flex.justify-content-center.my-3
          .btn-form.py-2.py-xl-3
            a(href='javascript:void(0);' @click="backToTop")
              .btn-submit {{ $t("ui.back_to_top") }}
</template>

<script>
import config from '@/config'
import _ from "lodash"

export default {
  components: {
    announcement: () => import("@/components/_announcement"),
    gameSearch: () => import("@/components/_gameSearch")
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading: false,
      gameList:[],      
      search: ""
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language
    },
    providerList() {
      return this.$store.state.user.account.provider_list.filter(item => item.enable_provider === true)
    },
    favGame() {
      return this.$store.getters.favGame
    },
    provider() {
      return this.$store.getters.provider
    }
  },
  created(){
		if(!this.getGameEnableStatus('LIVE22')){
			this.$router.push("/").catch(error =>{})
		}
	},
  mounted(){
    this.getGameList()
  },
  methods: {
    toggleFav(game) {
      let list = {
        "GameId": game.GameId,
        "GameName": game.GameName,
        "GameType": game.GameType,
        "ImageUrl": game.ImageUrl
      }

      if (this.isLoggedIn) {
        if(this.isFav(list.GameId)) {
          this.deleteMemberFavGame(list)
        } else {
          this.addMemberFavGame(list)
        }
      } else {
        $('#modal-login').modal('show')
      }
    },
    backToTop(event) {
      // Prevent the default behavior of jumping to the anchor link
      event.preventDefault(); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getGameEnableStatus(game){
			if(this.isLoggedIn){
        return this.providerList.filter(item => item.provider_code === game).length > 0
      }
      return true
		},
    isFav(code){
      return this.favGame.some(obj=> Number(obj.game_code) === code)
    },
    getGameList(){
      this.pageLoading = true
			var url = config.getLive22FishGameList()
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.gameList = successResponse.body.Game
              this.loading = false
            } else {
              this.loading = false
            }
          }else{
            this.loading = false
          }
        },
        err => {
          this.loading = false
        }
      );
    },
    launchGame(id){
      if (this.isLoggedIn) {
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = id
        let lang_code = "en"
        this.$store
          .dispatch("provider/launchLive22", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
          });
      } else {
				$('#modal-login').modal('show')
			}
    },
    getMemberFavGame() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberFavGame", { login_id, auth_token }).then(
          res => {
            this.loading = false
            if (res.success) {
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + res.status), "error")
            }
          },
          err => {
            this.loading = false
            this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + err.status), "error")
          }
        );
      }
    },
    addMemberFavGame(game) {
      if (this.isLoggedIn) {
        let login_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = this.provider
        let game_code = game.GameId
        let game_name = game.GameName
        let game_type = game.GameType
        let img_url = game.ImageUrl
        this.loading = true
        this.$store
          .dispatch("user/addMemberFavGame", { login_id, auth_token, provider_code, game_code, game_name, game_type, img_url })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.getMemberFavGame()
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false              
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("error." + response.status), "error")
          });
      }
    },
    deleteMemberFavGame(game) {
      if(this.isLoggedIn) {
        let login_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = this.provider
        let game_code = game.GameId
        this.loading = true
        this.$store
          .dispatch("user/deleteMemberFavGame", { login_id, auth_token, provider_code, game_code })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {   
              this.getMemberFavGame()
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false              
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error")
          });
      }
    },
    searchKey(search) {
      this.search = search.toLowerCase()
    },
    searchList() { 
      return this.gameList.filter((game) => game.GameName.toLowerCase().includes(this.search.toLowerCase()))
    }
  }
}
</script>